export default __webpack_public_path__ + "static/media/denis-firu.a60f22c4.png";